import { useId, useState } from "react";

import { Field, inputStyle } from "./Field";

interface StringListFieldProps {
  label: string;
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  helper?: React.ReactNode;
  disabled?: boolean;
}

// One entry per line. Keeps the raw textarea text in local state (so an
// in-progress blank line isn't yanked out from under the cursor) while
// emitting a trimmed, blank-free string[] to the parent on every change.
// Parents mount this with a stable `initial` (the editor remounts the form
// on data load), so local init from `value` is correct.
export function StringListField({
  label,
  value,
  onChange,
  placeholder,
  helper,
  disabled,
}: StringListFieldProps) {
  const id = useId();
  const [raw, setRaw] = useState(value.join("\n"));
  return (
    <Field label={label} htmlFor={id} helper={helper}>
      <textarea
        id={id}
        value={raw}
        disabled={disabled}
        placeholder={placeholder}
        rows={3}
        onChange={(e) => {
          setRaw(e.target.value);
          onChange(
            e.target.value
              .split("\n")
              .map((s) => s.trim())
              .filter(Boolean),
          );
        }}
        style={{ ...inputStyle, resize: "vertical" }}
      />
    </Field>
  );
}
